import { Box, Container, Typography, useTheme } from "@mui/material"

import { Head } from "components/Head"
import { Image } from "components/Image"
import { useMemo } from "react"
import { useHome } from "extensions/one-siam-landing-page/hooks/useHome"
import { AppNavigationBar } from "extensions/one-siam-landing-page/components/AppNavigationBar"

export const HomePage = () => {
  const theme = useTheme()
  const { navigations } = useHome()

  const {
    root,
    header,
    content,
    logo,
    venueSelectorContainer,
    venueSelectorLabel,
  } = theme.components[`HomePage`]?.styleOverrides || {}
  const logoSrc = useMemo(() => theme?.assets?.logo?.url, [theme])

  return (
    <>
      <Head title={"One Siam"} suffixTitle=" - Directory" />
      <Container maxWidth="sm" sx={root}>
        <Box sx={header}>
          <Image src={logoSrc} alt="logo" sx={logo} />
        </Box>
        <Box sx={content}>
          <Box sx={venueSelectorContainer}>
            <Typography variant="h5" sx={venueSelectorLabel}>
              Select location
            </Typography>
            <AppNavigationBar navigations={navigations} />
          </Box>
        </Box>
      </Container>
    </>
  )
}
